var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useDependencyList } from '../useDependencyList/useDependencyList';
export const useMemoExtended = (factory, deps, comparator) => {
    _react_refresh_temp_1();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Intentional
    return useMemo(factory, useDependencyList(deps, comparator));
};
_react_refresh_temp_1(useMemoExtended, "doD72d/T0GSMz0RlJ4qgMdsGduQ=", false, () => [useDependencyList]);
